import BaseModel from './base-model';
/**
 * format:
 * @REL_ATTR: "R"
 */
export default class Type extends BaseModel {
  constructor(opts = {}) {
    super(opts);
    this.relAttr = opts['@REL_ATTR'] || null;
  }
}
